import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GaBreadcrumbsModule } from 'gain-lib/breadcrumbs';
import { AppBreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';

@NgModule({
  declarations: [AppBreadcrumbsComponent],
  imports: [CommonModule, GaBreadcrumbsModule],
  exports: [AppBreadcrumbsComponent],
})
export class BreadcrumbsModule {}
